<template>
    <span class="regular px-2" :class="dynamicClasses" :style="dynamicStyles">
        <slot>{{ label }}</slot>
    </span>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: false,
                default: ''
            },
            color: {
                type: String,
                required: false,
                default: 'gray-100' 
            },
            bgcolor: {
                type: String,
                required: false,
                default: 'color-1'
            },
            radius: {
                type: Number,
                required: false,
                default: 10
            },
            fsize: {
                type: String,
                required: false,
                default: 'fs-2'

            }
        },
        computed: {
            dynamicClasses(){
                return [
                    this.color,
                    `${this.bgcolor}-bkg`,
                    this.fsize,
                    `b-1-${this.bgcolor}`
                ]
            },
            dynamicStyles(){
                return {
                    borderRadius: `${this.radius}px`
                }
            }
        }
    }
</script>